module.exports = __webpack_public_path__ + "static/media/sunk-ship.00468344.svg";